const einProgram = {
  einProgram: {
    pageHeader: 'Leads und Enphase Installer Network',
    title: 'EIN-Mitgliedschaft akzeptiert',
    overview: 'Übersicht',
    noCompany: 'Kein Unternehmen gefunden',
    goToDashboard: 'Dashboard öffnen',
    messageFromCeo: 'Lesen Sie die Nachricht von unserem CEO',
    companyProfileLink: 'Aktualisieren Sie Ihr Firmenprofil',
    serviceAreasLink: 'Wählen Sie Ihre Servicebereiche aus',
    leadsPreferencesLink: 'Legen Sie Ihre Leads-Einstellungen fest',
    reviewInstallerLink: 'Überprüfen Sie die Geschäftsbedingungen des Installationsprogramms',
    open: 'öffnen',
    video: 'Video',
    selected: 'ausgewählt',
    learnMore: 'Mehr erfahren',
    completed: 'Abgeschlossen',
    pending: 'Ausstehend',
    optInDisabledHeader: 'EIN-Programm (demnächst)',
    optInDisabledDescription:
      'Das Enphase Installer Network (EIN) ist für Hausbesitzer eine großartige Möglichkeit, Sie zu finden! Hausbesitzer vertrauen auf das EIN zur Suche von Installateuren, die beim Kundendienst und der Systemqualität bezüglich der Anwendung von Enphase-Produkten die höchsten Maßstäbe setzen. Als EIN-Mitglied erhalten Sie eine Reihe von Vorteilen, um höhere Absätze, mehr Installationen und größere Gewinne zu erzielen.',
    einTier: 'Ihr Level im Enphase Installer Network (EIN): ',
    none: 'Keine',
    viewBenefits: 'Um Ihre EIN-Vorteile anzuzeigen, klicken Sie ',
    here: 'hier',
    anyQuestions: ' Wenn Sie Fragen zu Ihrer EIN-Mitgliedschaft haben, wenden Sie sich bitte an Ihren',
    enphaseAccountRepresentative: ' Enphase Kundenbetreuer.',
    learnReceivingLeads: 'Erfahren Sie, wie Sie Leads über die digitale Enphase-Plattform erhalten. ',
    benefitsOfEIN: 'Die Vorteile des EIN anzeigen ',
    contactEnphaseRepresentative:
      '. Wenden Sie sich bitte an Ihren Enphase Kundenbetreuer, um mehr über das EIN und das Enphase Leads-Programm zu erfahren.',
    congratulations: 'Herzlichen Glückwunsch!',
    whichInstaller: '%{tierName} Installateur. ',
    invitationText1: 'Sie wurden zur Teilnahme am Enphase Installer Network (EIN) eingeladen als ',
    invitationText2:
      'Das Enphase Installer Network (EIN) ist das verlässliche Netzwerk aus Installateuren, die Hausbesitzern bei der Anwendung von Enphase-Produkten eine außergewöhnliche Erfahrung bieten. Das EIN stärkt unsere Beziehung zu Ihnen und beschleunigt Ihr Wachstum. Als EIN-Mitglied erhalten Sie eine Reihe von Vorteilen, um höhere Absätze, mehr Installationen und größere Gewinne zu erzielen. Schauen Sie sich alle Vorteile an',
    acceptInvitation: 'Um Ihre Einladung anzunehmen:',
    acceptTerms: 'Ich akzeptiere die Allgemeinen Geschäftsbedingungen',
    cellmodemCheck: 'Ich akzeptiere die',
    cellmodemTeamcondition: ' Allgemeinen Geschäftsbedingungen ',
    cellmodemLinkTitle: 'des Mobile Connect Datenerweiterung',
    notEstablished: 'Nicht festgelegt.',
    contactEin: 'Wenden Sie sich bitte an Ihren Enphase Kundenbetreuer, um mehr über das EIN zu erfahren.',
    getFreeLeads: 'Um kostenlose Leads zu erhalten, befolgen Sie die nachstehenden Schritte:'
  }
};

export default einProgram;
